// extracted by mini-css-extract-plugin
export default {"item1":"Footer_item1__lLWaZ","item2":"Footer_item2__iLOyF","item3":"Footer_item3__25YnI","redesSociais":"Footer_redesSociais__sWbGW"};